// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blog-slider .swiper-wrapper{padding-bottom:63px;z-index:99}.blog-slider.swiper-container-horizontal>.swiper-scrollbar{width:100%}@media (max-width:767px){.blog-slider .swiper-wrapper{padding-bottom:34px}}", ""]);
// Exports
module.exports = exports;
